import { SelectChangeEvent } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { LoaderFunctionArgs, useLoaderData, useNavigate } from "react-router-dom";
import { useGlobal } from "../../components/GlobalProviderLayout";
import { RESET_DATE, RESET_JOB, RESET_SHIFT, SET_DATE, SET_JOB, SET_SHIFT, defaultDate, defaultJob, defaultShift } from "../../components/GlobalProviderLayout/GlobalProviderLayoutModel";
import { doFetch } from "../../utils/doFetch";
import { DispatchAvailabilityListReport } from "./DispatchAvailabilityListReport";
import { DispatchAvailabilityListReportData, IJob } from "./DispatchAvailabilityListReportData";

export const dispatchAvailabilityListReportRouteLoader = async ({ request }: LoaderFunctionArgs) => {
  return doFetch(`audit-report/dispatch-availability`, { signal: request.signal }, true, true)
}

export const DispatchAvailabilityListReportRoute = () => {
  const data = useLoaderData() as DispatchAvailabilityListReportData;
  const navigate = useNavigate();
  const { state, dispatch } = useGlobal();
  const selectedDate = state.dateValue ?? defaultDate;
  const selectedShift = state.shift ?? defaultShift;
  const selectedJob = state.job ?? defaultJob;
  const [dateError, setDateError] = useState<string | null>("");
  const formattedDate = (date: Dayjs | null) => dayjs(date).format('DDMMYYYY');
  const disabledView = !selectedDate || selectedShift === "" || !selectedJob || !!dateError;
  const MAIN_ROUTE = '/dispatch-availability-list-report';

  useEffect(() => {
    if (!state.previousLocation?.includes(MAIN_ROUTE)) {
      dispatch({ type: RESET_DATE });
      dispatch({ type: RESET_SHIFT });
      dispatch({ type: RESET_JOB });
    }
  }, [dispatch, state.previousLocation]);

  useEffect(() => {
    if (!data.jobs.find(j => j.jobId === selectedJob.jobId)) {
      dispatch({ type: SET_JOB, payload: data.jobs[0] });
    }
  }, [dispatch, data.jobs, selectedJob]);

  const handleDateChange = (date: Dayjs | null) => {
    dispatch({ type: SET_DATE, payload: date ?? defaultDate });
  };

  const handleShiftChange = (event: SelectChangeEvent<string>) => {
    dispatch({ type: SET_SHIFT, payload: event.target.value });
  };

  const handleJobChange = (event: SelectChangeEvent<string>) => {
    const job = data.jobs.find(j => j.jobId === Number(event.target.value));
    dispatch({ type: SET_JOB, payload: job as IJob });
  };

  const handleSubmit = () => {
    navigate(`${MAIN_ROUTE}-results/${formattedDate(selectedDate)}/${selectedShift}/${selectedJob?.jobId}`);
  }

  const datePickerCompProps = {
    title: "Order Date",
    date: selectedDate,
    handleDateChange,
    onError: setDateError,
    error: dateError
  }

  return (
    <DispatchAvailabilityListReport
      datePickerCompProps={datePickerCompProps}
      dispatchType={selectedShift}
      disabledView={disabledView}
      selectedJob={selectedJob}
      jobs={data.jobs}
      handleSubmit={handleSubmit}
      handleShiftChange={handleShiftChange}
      handleJobChange={handleJobChange}
    />
  )
}